/**
 * groupByName — bucket rows by a key function, preserving first-seen group
 * order and input order within each group.
 *
 * The Observed-skills table folds rows sharing a `(vendor, name)` key into a
 * single collapsible group: distinct SKILL.md content under the same name
 * becomes sibling "variants". Endpoints often carry the same skill name with
 * differing bodies (a user edit, a plugin fork), so grouping keeps the table
 * scannable instead of repeating the name on every variant row.
 *
 * @template T
 * @param {T[]} rows
 * @param {(row: T) => string} key
 * @returns {{ key: string, rows: T[] }[]}
 */
export function groupByName(rows, key) {
    const order = [];
    const buckets = new Map();
    for (const row of rows ?? []) {
        const k = key(row);
        let bucket = buckets.get(k);
        if (!bucket) {
            bucket = [];
            buckets.set(k, bucket);
            order.push(k);
        }
        bucket.push(row);
    }
    return order.map((k) => ({ key: k, rows: buckets.get(k) }));
}
